import classNames from 'clsx';
import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import styles from './CommonStylesProvider.scss';

const CommonStylesProvider: React.FC<{
  children: ReactNode;
  className?: string;
  applyModalStyles?: boolean;
}> = ({ children, className, applyModalStyles }) => {
  const isEmbedded = useSelector(select.device.isEmbedded);

  return (
    <div
      className={classNames(className, {
        [styles.root]: !applyModalStyles,
        [styles.disableSelect]: isEmbedded
      })}
    >
      {children}
    </div>
  );
};

export default CommonStylesProvider;
